import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22f4cec0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view_content" }
const _hoisted_2 = { class: "image_box" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "echart_page" }
const _hoisted_5 = { class: "echart_tabs" }
const _hoisted_6 = { class: "echart_people" }
const _hoisted_7 = { class: "echart_message" }
const _hoisted_8 = { class: "online_people" }
const _hoisted_9 = { class: "online_hignlight" }
const _hoisted_10 = { class: "online_people" }
const _hoisted_11 = { class: "online_hignlight" }
const _hoisted_12 = { class: "echart_map" }
const _hoisted_13 = ["id"]
const _hoisted_14 = { class: "echart_view_link_wrap" }
const _hoisted_15 = { class: "echart_view_link" }
const _hoisted_16 = { class: "view_qic" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "手机二维码", -1))
const _hoisted_18 = {
  id: "qrcode",
  class: "view_img"
}
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "view_link" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "观看地址", -1))
const _hoisted_22 = { class: "view_button" }
const _hoisted_23 = ["href"]
const _hoisted_24 = { class: "echart_view_link_wrap" }
const _hoisted_25 = { class: "echart_view_link barrage_wrap" }
const _hoisted_26 = { class: "barrage_sub_title" }
const _hoisted_27 = { class: "bst_lang_title" }
const _hoisted_28 = { class: "bst_lang_conent" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bst_lang_title_txt" }, "原声语种", -1))
const _hoisted_30 = { class: "bst_lang_title" }
const _hoisted_31 = { class: "bst_lang_conent" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bst_lang_title_txt" }, "字幕语种", -1))
const _hoisted_33 = { class: "barrage_sub_content" }
const _hoisted_34 = { class: "loading_content" }
const _hoisted_35 = {
  key: 0,
  class: "vjs-big-vr-play-button vr_video_logo"
}

import { computed, nextTick, onMounted, onUnmounted, createVNode, reactive, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { message, Button, Input, Select, Modal } from 'ant-design-vue';
import * as echarts from 'echarts';
import ClipboardJS from 'clipboard';
import 'video.js/dist/video-js.css';
import { useQRCode } from '@vueuse/integrations/useQRCode';
import videojs from 'video.js';
import 'videojs-flvjs-es6';
import { AliRTS } from 'aliyun-rts-sdk';
import { useConsoleStore } from '@/pinia/console';
import http from '@/api';
import { ExclamationCircleFilled } from '@ant-design/icons-vue';
import acousticwave from './acousticwave.vue';
import { useStore } from 'vuex';

// `qrcode` will be a ref of data URL
// import http from '@/api/control/liveInformation';
import EventBus from '@/components/EventBus';
import { useHomeStore } from '@/pinia/home';
import { useLiveStore } from '@/pinia/live';
import { AiSubitObj } from '@/pinia/types/live';
import { getHelperStatus } from '@/plugins/cookie';

import 'videojs-vr';
import 'videojs-vr/dist/videojs-vr.css';

interface SocketSubtitlesType {
  lang: string;
  text: any;
  type: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'LiveView',
  setup(__props) {

const aButton = Button;
const aInput = Input;
const aSelect = Select;
const route = useRoute();
const studioId = route.params.studioId;
const homeStore = useHomeStore();
const liveStore = useLiveStore();
const consoleState = useConsoleStore();
const videoWrapRef = ref();
const videoRef = ref();
const videoPlayer = ref(); // 播放器实例
const videoAliRts = ref<any>(undefined);
const qrCodeUrl = computed(() => consoleState.consoleInfo.qrCodeUrl);
const qrcode = useQRCode(qrCodeUrl, {
  margin: 0,
});

const consoleStore = useConsoleStore();
const isShow3D = computed(() => consoleStore.consoleInfo.vrPlayStatus === 1 || consoleStore.consoleInfo.vrPlayStatus === 2);
const vrPlaySwitch = computed(() => consoleStore.consoleInfo.vrPlaySwitch); //仅支持3d播放开关

const options = {
  // poster: poster,//海报
  // playbackRates: [0.7, 1.0, 1.5, 2.0],//播放速度
  language: 'zh-CN',
  notSupportedMessage: '此视频暂时无法播放,请稍后再试',
  controls: true,
  techOrder: ['html5', 'flvjs'], //html5模式和flvjs模式
  fluid: true, //流式布局,适应父元素大小
  flvjs: {
    mediaDataSource: {
      isLive: true, //是否是直播
      cors: true, //是否跨域
      withCredentials: false, //是否跨站检测
    },
  },
  preload: true, //预加载
  autoplay: true, //是否自动播放
};
const isShowVideoPlay = ref(false); //播放器实例是否存在
const isVrVideoFlow = computed(() => consoleState.consoleInfo.vrPlayUrl.includes(videoPlayer.value.src())); //是否正在播放3d视频

// 切换3d视频
const cutVrPlayer = (type: string) => {
  videoPlayer.value.dispose();
  isShowVideoPlay.value = false;

  videoWrapRef.value.innerHTML = `<video
          id="videojs-player"
          controls
          class="video-js vjs-matrix vjs-default-skin vjs-big-play-centered vjs-16-9"
        ></video>`;

  nextTick(() => {
    videoPlayer.value = videojs('videojs-player', options);
    isShowVideoPlay.value = true;
    if (type === '3d') {
      initVrPlayer();
      onVrLiveing();
    } else {
      videojsPlay();
      onLiveing();
    }
  });
};

// 初始化3d视频
const initVrPlayer = () => {
  videoPlayer.value.src({
    src: consoleState.consoleInfo.vrPlayUrl[1],
    type: 'video/x-flv',
  });
  videoPlayer.value.mediainfo = videoPlayer.value.mediainfo || {};
  videoPlayer.value.mediainfo.projection = '360';
  videoPlayer.value.vr({ projection: 'AUTO', debug: true, forceCardboard: false });
};

// 监听仅支持3D播放开关
watch(
  () => vrPlaySwitch.value,
  (nal) => {
    if (nal && !isVrVideoFlow.value) {
      cutVrPlayer('3d');
    }
  }
);

const onVrLiveing = () => {
  videoPlayer.value.on('timeupdate', function () {
    // 计算表最新推流的时间和现在播放器播放推流的时间
    let differTime = videoPlayer.value.buffered().end(0) - videoPlayer.value.currentTime();
    // 差值大于10s时进行重新加载直播流
    if (differTime > 10) {
      console.info('重新刷新流!!');
      // 注意这里重新加载video是自己封装的方法，需要销毁video并重新创建video
      initVrPlayer();
    }
  });
};

const videojsPlay = () => {
  if (consoleState.consoleInfo.liveUrlSwitch === 1) {
    videoPlayer.value.load();
    if (consoleState.consoleInfo.pushType) {
      videoPlayer.value.src({
        src: consoleState.consoleInfo.playUrl[3],
      });
      videoPlayer.value.on('error', function () {
        videoPlayer.value.errorDisplay.close(); //将错误信息不显示
      });
      videoAliRts.value = AliRTS.createClient();
      videoAliRts.value
        .isSupport({ isReceiveVideo: false })
        .then(() => {
          videoAliRts.value
            .subscribe(consoleState.consoleInfo.playUrl[3])
            .then((remoteStream: any) => {
              remoteStream.play(document.getElementById('videojs-player_html5_api'));
            })
            .catch(() => {
              // 订阅失败
            });
          //可用
        })
        .catch(() => {
          //不可用
          alert('您的浏览器不支持该直播协议，请更换至谷歌浏览器');
        });
    } else {
      const ua = navigator.userAgent.toLowerCase();
      ua.includes('micromessenger');
      if (ua.includes('micromessenger')) {
        videoPlayer.value.src({
          src: consoleState.consoleInfo.playUrl[2],
          type: 'application/x-mpegURL',
        });
      } else {
        if (isShow3D.value && vrPlaySwitch.value) {
          initVrPlayer();
        } else {
          videoPlayer.value.src({
            src: consoleState.consoleInfo.playUrl[1],
            type: 'video/x-flv',
          });
        }
      }
      videoPlayer.value.play();
    }
  }
};

const map = ref(`map${Date.now() + Math.random()}`);
const hisOnlineChartData = reactive<any>({
  dates: [],
  nums: [],
});
let historyOnlineCharts: echarts.ECharts;
const historyOnlineChartsOption = (sourceData: any) => {
  historyOnlineCharts.setOption({
    tooltip: {
      trigger: 'axis',
      position(pt: any) {
        return [pt[0], '10%'];
      },
    },
    toolbox: {
      feature: {},
    },
    grid: {
      y2: 40,
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: sourceData.dates,
    },
    yAxis: {
      type: 'value',
      minInterval: 1, // 最小步长
      boundaryGap: [0, '100%'],
      splitLine: {
        show: false,
      },
    },
    // 下面的进度条
    dataZoom: [
      {
        bottom: 10,
        height: 10,
      },
      {
        type: 'inside',
      },
    ],
    series: [
      {
        name: '观看量',
        type: 'line',
        symbol: 'none',
        sampling: 'lttb',
        itemStyle: {
          color: 'rgba(0, 204, 176, 1)',
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: 'rgba(0, 204, 176, 1)',
            },
            {
              offset: 1,
              color: 'rgba(0, 204, 176, 0)',
            },
          ]),
        },
        data: sourceData.nums,
      },
    ],
  });
};

const onLiveing = () => {
  videoPlayer.value.on('timeupdate', function () {
    // console.log('正在播放------');
    // 计算表最新推流的时间和现在播放器播放推流的时间
    let differTime = videoPlayer.value.buffered().end(0) - videoPlayer.value.currentTime();
    // console.info('---!!', differTime);
    // 差值大于10s时进行重新加载直播流
    if (differTime > 10) {
      console.info('重新刷新流!!');
      // 注意这里重新加载video是自己封装的方法，需要销毁video并重新创建video
      onPlayVideo();
    }
  });
};
onMounted(() => {
  window.onresize = function () {
    historyOnlineCharts.resize();
  };
  videoPlayer.value = videojs(videoRef.value, options);
  isShowVideoPlay.value = true;
  videojsPlay();
  onLiveing();
});

onUnmounted(() => {
  videoPlayer.value.dispose();
});

// 复制
const Copylist = (btns: string) => {
  const ClipboardJSObj = new ClipboardJS(btns);
  // eslint-disable-next-line func-names
  ClipboardJSObj.on('success', function (e) {
    message.destroy();
    message.info('复制成功');
    e.clearSelection();
  });
  // eslint-disable-next-line func-names
  ClipboardJSObj.on('error', function () {
    message.destroy();
    message.info('复制失败');
  });
};

const historyOnline = () => {
  let history = {
    studio_id: studioId,
    start_at: consoleState.consoleInfo.startTime,
  };
  http.liveInformation.getHistoryOnline({ params: history }).then((res) => {
    const resData = res.data.data;
    // liveData.value = resData;
    const dateArr: string[] = [];
    const numArr: number[] = [];
    if (resData.length) {
      Object.keys(resData).forEach((res) => {
        dateArr.push(resData[res]['created_at']);
        numArr.push(resData[res]['number']);
      });
    }
    hisOnlineChartData.dates = dateArr;
    hisOnlineChartData.nums = numArr;
    // 在线人数图表
    const chartDo: HTMLElement = document.getElementById(map.value) as HTMLElement;
    historyOnlineCharts = echarts.init(chartDo);
    historyOnlineChartsOption(hisOnlineChartData);
  });
};

const online_number = (data: any) => {
  hisOnlineChartData.dates.push(data.created_at);
  hisOnlineChartData.nums.push(data.number);
  historyOnlineChartsOption(hisOnlineChartData);
};
const onPlaylive = (data: any) => {
  consoleState.consoleInfo.pushType = Boolean(data.push_type);
  consoleState.consoleInfo.liveUrlSwitch = data.status; // 播流状态
  if (data.status !== 1) {
    videoPlayer.value.pause();
  }
  videojsPlay();
};

const onPlayVideo = (data?: any) => {
  videoPlayer.value.dispose();
  isShowVideoPlay.value = false;
  videoWrapRef.value.innerHTML = `<video
          id="videojs-player"
          controls
          class="video-js vjs-matrix vjs-default-skin vjs-big-play-centered vjs-16-9"
        ></video>`;
  if (videoAliRts.value) {
    videoAliRts.value.unsubscribe();
  }
  if (data) {
    consoleState.consoleInfo.playUrl = data.playUrl;
    consoleState.consoleInfo.pushType = Boolean(data.push_type);
    consoleState.consoleInfo.liveUrlSwitch = 0;
    consoleState.consoleInfo.liveUrlSwitch = data.status;
  }
  nextTick(() => {
    videoPlayer.value = videojs('videojs-player', options);
    isShowVideoPlay.value = true;
    videojsPlay();
    onLiveing();
  });
};

const pageLoading = ref(false); //开关
// 字幕对象
const aiSubit = reactive<AiSubitObj>({
  status: 0,
  switch: 0,
  native_language: 0,
  current_language: 0,
  caption_language: [0],
  logo_switch: 0,
  logo_id: 0,
  logo_url: '',
  subtitle_archive: 0,
  allow_copying: 0,
  display_style: 0,
  caption_switch: 0,
});

const langOptions = ref<{ value: number; label: string }[]>([]); // 原声字幕 options
const capLangOptions = ref<{ value: number; label: string }[]>([]); // 翻译字幕 options
const langList = ref<{ id: number; language: string; language_code: string }[]>([]); // 原声字幕 option对象（包含语言码）

const store = useStore();
const helperStatus = getHelperStatus();
const aiSubitilesRole = computed(() => {
  const roleSubitil = (homeStore.funcData?.AiSubtitles && liveStore.aiSubitSwitch) || aiSubit.switch;
  if (!helperStatus) {
    return roleSubitil;
  } else {
    return store.state.user.helperInfo.set === 1 && roleSubitil;
  }
});
const formLangCode = computed(() => langList.value.find((item) => item.id === aiSubit.native_language)?.language_code); // 原声语言码
const formCapLangCode = computed(() => langList.value.find((item) => item.id === aiSubit.current_language)?.language_code); // 翻译语言码
const isMergebox = computed(() => aiSubit.current_language === aiSubit.native_language); // 合并字幕框的标识
// 字幕初始化
const getAIstrInfo = () => {
  pageLoading.value = false;
  Promise.all([http.live.getCaptionLanguageList(), http.live.getMultSubtitle({ params: { studio_id: studioId } })])
    .then(([res1, res2]) => {
      const resLang = res1.data.data;
      langList.value = resLang;
      langOptions.value = resLang.reduce((pre: { value: number; label: string }[], crr: { id: number; language: string }) => {
        pre.push({
          value: crr.id,
          label: crr.language,
        });
        return pre;
      }, [] as any);
      // res2
      const resSubtitle = res2.data.data;
      aiSubit.status = parseInt(resSubtitle.status);
      aiSubit.subtitle_archive = parseInt(resSubtitle.subtitle_archive);
      aiSubit.allow_copying = parseInt(resSubtitle.allow_copying);
      aiSubit.display_style = parseInt(resSubtitle.display_style);
      aiSubit.logo_switch = parseInt(resSubtitle.logo_switch);
      aiSubit.switch = parseInt(resSubtitle.switch);
      const keywordNat = parseInt(resSubtitle.native_language);
      aiSubit.native_language = keywordNat ? keywordNat : langOptions.value[0].value;
      const keywordCap = parseInt(resSubtitle.current_language);
      aiSubit.current_language = keywordCap ? keywordCap : langOptions.value[0].value;
      const capArritem = resSubtitle.caption_language.split(',').map(Number);
      aiSubit.caption_language = capArritem[0] ? capArritem : [langOptions.value[0].value];
      aiSubit.caption_switch = parseInt(resSubtitle.caption_switch);
      capLangOptions.value = langOptions.value.filter((item) => aiSubit.caption_language.includes(item.value));
      liveStore.aiSubitSwitch = Boolean(aiSubit.switch);
    })
    .catch((err: any) => {
      message.error(err.data.error);
    })
    .finally(() => {
      pageLoading.value = true;
    });
};

const tabs = ref(0); // Tab栏默认项
watch(
  () => aiSubit.switch,
  (newVal) => {
    if (!newVal) {
      tabs.value = tabs.value === 2 ? 0 : tabs.value;
    }
  }
);
const setTabs = (data: number) => {
  tabs.value = data;
  if (data === 0) {
    historyOnline();
    return;
  }
  if (data === 2 && homeStore.funcData?.AiSubtitles) {
    getAIstrInfo();
  }
};
// 初始化函数
const getBaseInfo = () => {
  historyOnline();
  if (homeStore.funcData?.AiSubtitles) {
    getAIstrInfo();
  }
};
getBaseInfo();
// 开启or重启字幕
const setAistrInfo = (keyWord: string, key?: number) => {
  let modalMessage = '开启';
  let formSwitch = 1;
  let isReset = false;
  if (keyWord === 'swith' && aiSubit.caption_switch === 1) {
    modalMessage = '关闭';
    formSwitch = 0;
  }
  if (keyWord === 'swith' && key) {
    modalMessage = '重新启动';
    formSwitch = key;
    isReset = true;
  }
  Modal.confirm({
    centered: true,
    icon: createVNode(ExclamationCircleFilled),
    content: `确认${modalMessage}多语实时字幕？`,
    onOk() {
      return new Promise((resolve, reject) => {
        http.live
          .setCaptionSwitch({
            params: {
              studio_id: studioId,
              caption_switch: formSwitch,
              lang: formLangCode.value,
              subtitle_lang: formCapLangCode.value,
            },
          })
          .then((res) => {
            message.success(res.data.message);
            if (isReset) {
              subTitleReset();
            } else {
              aiSubit.caption_switch = formSwitch;
            }
            resolve({});
          })
          .catch((err) => {
            message.error(err.data.error);
            resolve(err);
          });
      });
    },
  });
};

const subTitlesSet = ref(new Map()); // 字幕的 Map 对象数组
const socketSubtitles = ref<Map<string, any>>(new Map());
const subLang = ref({});
const nativeLangRef = ref<Element>(); // 原生显示框
const captionLangRef = ref<Element>(); // 翻译显示框DOM
const nextClearState = reactive({
  native: false,
  caption: false,
});
const langLoading = computed(() => aiSubit.caption_switch && subTitlesSet.value.size === 0 && socketSubtitles.value.size === 0);
const nativeLangContent = computed(() => {
  if (!subTitlesSet.value.get(formLangCode.value)) return '';
  return subTitlesSet.value.get(formLangCode.value).baseTxt + subTitlesSet.value.get(formLangCode.value).nowTxt;
});
const captionLangContent = computed(() => {
  if (!subTitlesSet.value.get(formCapLangCode.value)) return '';
  // return subTitlesSet.value.get(formCapLangCode.value).join('');
  return subTitlesSet.value.get(formCapLangCode.value).baseTxt + subTitlesSet.value.get(formCapLangCode.value).nowTxt;
});

watch(nativeLangContent, () => {
  nextTick(() => {
    nativeLangRef.value && (nativeLangRef.value.scrollTop = nativeLangRef.value.scrollHeight);
  });
});
watch(captionLangContent, () => {
  nextTick(() => {
    captionLangRef.value && (captionLangRef.value.scrollTop = captionLangRef.value.scrollHeight);
  });
});

const setClearStatus = (lang: string) => {
  if (nativeLangRef.value && nativeLangRef.value.scrollHeight > nativeLangRef.value.clientHeight && formLangCode.value === lang) {
    nextClearState.native = true;
  }
  if (
    captionLangRef.value &&
    captionLangRef.value.scrollHeight > captionLangRef.value.clientHeight &&
    formCapLangCode.value === lang
  ) {
    nextClearState.caption = true;
  }
};

const clearLangData = (lang: string) => {
  if (nextClearState.native && lang === formLangCode.value) {
    subTitlesSet.value.get(formLangCode.value).baseTxt = '';
    subTitlesSet.value.get(formLangCode.value).nowTxt = '';
    nextClearState.native = false;
  }
  if (nextClearState.caption && lang === formCapLangCode.value) {
    subTitlesSet.value.get(formCapLangCode.value).baseTxt = '';
    subTitlesSet.value.get(formCapLangCode.value).nowTxt = '';
    nextClearState.caption = false;
  }
};

const msgTimer = ref<any>();
const updateSubtitle = (socketData: SocketSubtitlesType) => {
  const type = socketData.text?.header?.name; // 字幕类型
  const str = socketData.text?.payload?.result; // 字幕内容
  if (!str) return;
  if (type === 'SentenceEnd') {
    subTitlesSet.value.get(socketData.lang).baseTxt += str;
    subTitlesSet.value.get(socketData.lang).nowTxt = '';
    setClearStatus(socketData.lang);
    return;
  }
  if (!subTitlesSet.value.has(socketData.lang)) {
    subTitlesSet.value.set(socketData.lang, {
      baseTxt: '',
      nowTxt: '',
    });
  }
  clearLangData(socketData.lang);
  subTitlesSet.value.get(socketData.lang).nowTxt = str;
};
// 字幕更新
const msgInterval = () => {
  msgTimer.value = setInterval(() => {
    for (const item in subLang.value) {
      if (socketSubtitles.value.get(item).length > 0) {
        const data = socketSubtitles.value.get(item).shift() as SocketSubtitlesType;
        updateSubtitle(data);
      }
    }
  }, 200);
};

const onAddAllLang = (data: any) => {
  if (!data?.lang) return;
  // const str = data?.text?.payload?.result; // 字幕内容
  if (!socketSubtitles.value.has(data.lang)) {
    subLang.value[data.lang] = 0;
    socketSubtitles.value.set(data.lang, []);
    return;
  }
  socketSubtitles.value.get(data.lang).push(data);
  if (!msgTimer.value) msgInterval();
};

// 重启清空
const subTitleReset = () => {
  socketSubtitles.value.clear();
  subTitlesSet.value.clear();
};

EventBus.on('online_number', online_number);
EventBus.on('liveStatus', onPlaylive);
EventBus.on('Videoplay', onPlayVideo);
EventBus.on('rtasr', onAddAllLang);
EventBus.on('onUpdateSubt', getAIstrInfo);
onUnmounted(() => {
  EventBus.off('online_number', online_number);
  EventBus.off('liveStatus', onPlaylive);
  EventBus.off('Videoplay', onPlayVideo);
  EventBus.off('rtasr', onAddAllLang);
  EventBus.off('onUpdateSubt', getAIstrInfo);
  clearInterval(msgTimer.value);
});

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["video_page", { qtv_vr_video: isShowVideoPlay.value && _unref(isShow3D) && !_unref(vrPlaySwitch) }])
      }, [
        _withDirectives(_createElementVNode("div", {
          ref_key: "videoWrapRef",
          ref: videoWrapRef,
          class: "video_play"
        }, [
          _createElementVNode("video", {
            ref_key: "videoRef",
            ref: videoRef,
            id: "videojs-player",
            controls: "",
            class: "video-js vjs-matrix vjs-default-skin vjs-big-play-centered vjs-16-9"
          }, null, 512)
        ], 512), [
          [_vShow, _unref(consoleState).consoleInfo.liveUrlSwitch === 1]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("img", {
            src: _unref(consoleState).consoleInfo.imagePlayerCoverUrl
          }, null, 8, _hoisted_3), [
            [_vShow, _unref(consoleState).consoleInfo.imagePlayerCoverUrl]
          ])
        ], 512), [
          [_vShow, _unref(consoleState).consoleInfo.liveUrlSwitch !== 1]
        ])
      ], 2),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["tabs_radio", tabs.value == 0 ? 'tabs_radios' : '']),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (setTabs(0)))
          }, "实时数据", 2),
          _createElementVNode("div", {
            class: _normalizeClass(["tabs_radio", tabs.value == 1 ? 'tabs_radios' : '']),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (setTabs(1)))
          }, "观看链接", 2),
          (_unref(aiSubitilesRole))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["tabs_radio", tabs.value == 2 ? 'tabs_radios' : '']),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (setTabs(2)))
              }, "实时字幕", 2))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createTextVNode(" 在线并发人数："),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(consoleState).consoleInfo.uvCount), 1),
              _createTextVNode("人 ")
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createTextVNode(" 观看量(pv): "),
              _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(consoleState).consoleInfo.pvCount), 1),
              _createTextVNode("次 ")
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", {
              id: map.value,
              class: "map"
            }, null, 8, _hoisted_13)
          ])
        ], 512), [
          [_vShow, tabs.value === 0]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("img", {
                  src: _unref(qrcode),
                  alt: "QR Code"
                }, null, 8, _hoisted_19)
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createVNode(_unref(aInput), {
                value: _unref(consoleState).consoleInfo.qrCodeUrl,
                id: "warrants",
                class: "repeat_input",
                readonly: ""
              }, null, 8, ["value"]),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_unref(aButton), {
                  class: "view_btns warrant",
                  "data-clipboard-target": "#warrants",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (Copylist('.warrant')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("复制")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(aButton), {
                  type: "primary",
                  class: "view_btn"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      href: _unref(consoleState).consoleInfo.qrCodeUrl,
                      target: "_blank"
                    }, "打开", 8, _hoisted_23)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ], 512), [
          [_vShow, tabs.value === 1]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createVNode(_unref(aSelect), {
                    class: "bst_lang_title_select primary",
                    value: aiSubit.native_language,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((aiSubit.native_language) = $event)),
                    options: langOptions.value
                  }, {
                    suffixIcon: _withCtx(() => [
                      _createVNode(_component_svg_icon, {
                        class: "mod_select_icon",
                        "icon-class": "live_view_select_down"
                      })
                    ]),
                    _: 1
                  }, 8, ["value", "options"])
                ]),
                _createVNode(_unref(aButton), {
                  type: "link",
                  class: "bst_lang_title_switch primary",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (setAistrInfo('swith')))
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_svg_icon, { "icon-class": "live_view_btn_paused" }, null, 512), [
                      [_vShow, aiSubit.caption_switch]
                    ]),
                    _withDirectives(_createVNode(_component_svg_icon, { "icon-class": "live_view_btn_start" }, null, 512), [
                      [_vShow, !aiSubit.caption_switch]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_unref(aButton), {
                  type: "link",
                  class: "bst_lang_title_switch",
                  disabled: aiSubit.caption_switch === 0,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (setAistrInfo('swith', 2)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_svg_icon, {
                      class: "",
                      "icon-class": "live_view_btn_refresh"
                    })
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createElementVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _createVNode(_unref(aSelect), {
                    class: "bst_lang_title_select primary",
                    value: aiSubit.current_language,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((aiSubit.current_language) = $event)),
                    options: capLangOptions.value
                  }, {
                    suffixIcon: _withCtx(() => [
                      _createVNode(_component_svg_icon, {
                        class: "mod_select_icon",
                        "icon-class": "live_view_select_down"
                      })
                    ]),
                    _: 1
                  }, 8, ["value", "options"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _withDirectives(_createElementVNode("div", _hoisted_34, [
                _createVNode(acousticwave)
              ], 512), [
                [_vShow, _unref(langLoading)]
              ]),
              _createElementVNode("div", {
                ref_key: "nativeLangRef",
                ref: nativeLangRef,
                class: _normalizeClass(["barrage_sub_content_tbody", _unref(isMergebox) ? '' : 'border-1'])
              }, [
                _createElementVNode("div", null, _toDisplayString(_unref(nativeLangContent)), 1)
              ], 2),
              _withDirectives(_createElementVNode("div", {
                ref_key: "captionLangRef",
                ref: captionLangRef,
                class: "barrage_sub_content_tbody"
              }, [
                _createElementVNode("div", null, _toDisplayString(_unref(captionLangContent)), 1)
              ], 512), [
                [_vShow, !_unref(isMergebox)]
              ])
            ])
          ])
        ], 512), [
          [_vShow, tabs.value === 2]
        ])
      ])
    ]),
    (isShowVideoPlay.value && _unref(isShow3D) && !_unref(vrPlaySwitch))
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: ".vjs-big-play-centered"
        }, [
          (!_unref(isVrVideoFlow))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "vjs-big-play-button twe_btn",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (cutVrPlayer('3d')))
              }, "3d"))
            : _createCommentVNode("", true),
          (_unref(isVrVideoFlow))
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "vjs-big-play-button twe_btn",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (cutVrPlayer('2d')))
              }, "2d"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (isShowVideoPlay.value && _unref(isShow3D))
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 1,
          to: ".vjs-big-play-centered"
        }, [
          (_unref(isVrVideoFlow))
            ? (_openBlock(), _createElementBlock("div", _hoisted_35))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})